if (!customElements.get("product-media-gallery")) {
  class ProductMediaGallery extends HTMLElement {
    constructor() {
      super();

      const initialSlide = Number(this.dataset.initialSlide);

      /** @type {Swiper} */
      this.thumbs = new window.Swiper(
        this.querySelector(".swiper-thumbs"),
        this.thumbsOptions()
      );

      /** @type {Swiper} */
      this.main = new window.Swiper(
        this.querySelector(".swiper-main"),
        this.mainOptions()
      );

      this.main.slideTo(initialSlide);
      this.listenVariantChange();
    }

    thumbsOptions() {
      return {
        slidesPerView: Number(this.dataset.thumbsPerView) || 4,
        spaceBetween: 10,
        freeMode: true,
        watchSlidesProgress: true,
      };
    }

    mainOptions() {
      return {
        speed: Number(this.dataset.speed) || 300,
        rewind: true,
        pagination: {
          type: "bullets",
          el: ".swiper-pagination",
          clickable: true,
        },
        navigation: {
          nextEl: this.querySelector(".swiper-button-next"),
          prevEl: this.querySelector(".swiper-button-prev"),
        },
        thumbs: {
          swiper: this.thumbs,
          autoScrollOffset: 1,
        },
      };
    }

    listenVariantChange() {
      window.addEventListener(
        "kt.product.variant.change",
        (event) => {
          const selectedVariant = event.detail;

          if (selectedVariant?.image_id) {
            const slideIndex = this.getSlideIndexByImageId(
              selectedVariant.image_id
            );
            this.main.slideTo(slideIndex);
          } else {
            this.main.slideTo(0); // Default to first slide if no image_id
          }
        },
        false
      );
    }

    getSlideIndexByImageId(image_id) {
      const slides = this.querySelectorAll(".swiper-main .swiper-slide");
      for (let i = 0; i < slides.length; i++) {
        if (parseInt(slides[i].getAttribute("data-image-id")) === image_id) {
          return i;
        }
      }
      return 0; // Default to first slide if not found
    }
  }

 customElements.define("product-media-gallery", ProductMediaGallery);
}

if (!customElements.get('product-form')) {
  class ProductFormElement extends HTMLElement {
    constructor() {
      super();
      this.form = this.querySelector('form');
      if (this.form) {
        this.form.addEventListener('submit', this.onSubmit.bind(this));
      }
    }

    onSubmit(event) {
      event.preventDefault();
      const formData = new FormData(this.form);
      document.querySelector('cart-container')?.add(formData);
    }
  }

  customElements.define('product-form', ProductFormElement);
}
